export default {
  namespaced: true,
  state: {
    disconnected: false,
    message: ""
  },
  getters: {
    disconnected: state => state.disconnected,
    message: state => state.message
  },
  mutations: {
    setDisconnected(state, disconnected) {
      state.disconnected = disconnected
    },
    setMessage(state, message) {
      state.message = message
    }
  }
}
